// How many pax a per_pax invoice cost row applies to — the one rule used everywhere an
// invoice's cost/GP is computed or posted: a pax-type row (a package's per-type rate)
// counts only lines of that type (0 when there are none, e.g. an Adult rate on a
// child-only invoice), a row assigned to one passenger counts only that line, and a
// shared row counts everyone. Older lines carry their type only as the
// "Adult — Travel Package" description prefix.
export const lineTypeOf = (l) => l.type || (l.description || '').split(' — ')[0].trim();

export function costPaxQty(c, items) {
  if (c.pax_type_filter) return items.reduce((s, l) => lineTypeOf(l) === c.pax_type_filter ? s + (parseFloat(l.qty) || 1) : s, 0);
  if (c.line_item_index !== '' && c.line_item_index != null) {
    const it = items[parseInt(c.line_item_index)];
    return it ? (parseFloat(it.qty) || 1) : 1;
  }
  return items.reduce((s, l) => s + (parseFloat(l.qty) || 0), 0) || 1;
}

// Total LKR cost of an invoice's cost_items.
export function invoiceCostLKR(inv) {
  const items = inv.line_items || [];
  return (inv.cost_items || []).reduce((s, c) => {
    const base = (parseFloat(c.cost_amount) || 0) * (parseFloat(c.exchange_rate) || 1);
    return s + (c.per_pax ? base * costPaxQty(c, items) : base);
  }, 0);
}
